<template>
  <div>
    <b-table
        :items="rows"
        :fields="fields"
        small
        hover
        responsive
        sort-by="peak"
        :sort-compare="sortCompare"
        show-empty
        empty-text="В чартах не было"
    >
      <template #cell(title)="{ item }">
        <b-link @click="openHistory(item.song_id)">{{ item.artist_name }} — {{ item.title }}</b-link>
      </template>
      <template #cell(peak)="{ item }">
        <span v-if="item.years">{{ item.years }}</span>
        <b-badge v-else :variant="item.peak === 1 ? 'warning' : 'light-primary'">#{{ item.peak }}</b-badge>
      </template>
    </b-table>
    <chart-song-history-modal v-model="isHistoryVisible" :song-id="historySongId"/>
  </div>
</template>

<script>
import { BTable, BLink, BBadge } from 'bootstrap-vue'
import { computed, ref } from '@vue/composition-api'
import ChartSongHistoryModal from './ChartSongHistoryModal.vue'

export default {
  components: {
    BTable, BLink, BBadge, ChartSongHistoryModal,
  },
  props: {
    songs: { type: Array, default: () => [] },
    chartFilter: { type: String, default: null },
  },
  setup(props) {
    const isHistoryVisible = ref(false)
    const historySongId = ref(null)

    // У строк премий нет числовых показателей — показываем прочерк
    const dashIfEmpty = value => (value === undefined || value === null || value === '' ? '—' : value)

    const fields = [
      { key: 'chart_name', label: 'Чарт', sortable: true },
      { key: 'title', label: 'Песня / альбом' },
      { key: 'peak', label: 'Пик / годы', sortable: true },
      {
        key: 'weeks_total', label: 'Недель', sortable: true, formatter: dashIfEmpty,
      },
      {
        key: 'weeks_at_1', label: 'На №1', sortable: true, formatter: dashIfEmpty,
      },
      {
        key: 'first_week', label: 'Первая неделя', sortable: true, formatter: dashIfEmpty,
      },
      {
        key: 'last_week', label: 'Последняя', sortable: true, formatter: dashIfEmpty,
      },
    ]

    // Строка = песня × чарт; у годовых чартов премий вместо пика/недель — годы
    const rows = computed(() => props.songs.flatMap(song => [
      ...(song.stats || [])
        .filter(stat => !props.chartFilter || stat.chart_slug === props.chartFilter)
        .map(stat => ({
          ...stat,
          song_id: song.id,
          title: song.title,
          artist_name: song.artist_name,
        })),
      ...(song.awards || [])
        .filter(award => !props.chartFilter || award.chart_slug === props.chartFilter)
        .map(award => ({
          chart_slug: award.chart_slug,
          chart_name: award.chart_name,
          years: award.years.join(', '),
          first_year: award.years.length ? Math.min(...award.years) : 0,
          song_id: song.id,
          title: song.title,
          artist_name: song.artist_name,
        })),
    ]))

    // Сортировка по «Пик / годы»: строки премий (без peak) идут после строк с пиком
    // (при убывании — перед ними), между собой — по первому году. Остальные колонки — по умолчанию
    const sortCompare = (rowA, rowB, key) => {
      if (key !== 'peak') return null
      const isAwardA = rowA.peak === undefined || rowA.peak === null
      const isAwardB = rowB.peak === undefined || rowB.peak === null
      if (isAwardA && isAwardB) return rowA.first_year - rowB.first_year
      if (isAwardA) return 1
      if (isAwardB) return -1
      return rowA.peak - rowB.peak
    }

    const openHistory = songId => {
      historySongId.value = songId
      isHistoryVisible.value = true
    }

    return {
      fields, rows, sortCompare, isHistoryVisible, historySongId, openHistory,
    }
  },
}
</script>
